// src/services/storageInvoiceTemplates.js
// HTML template generation for storage invoices (website version)
// Placeholder for future storage invoice functionality

/**
 * Generate Storage Invoice HTML
 * Placeholder - implement when storage invoices are needed
 */
export const generateStorageInvoiceHTML = (invoice) => {
  // Placeholder implementation
  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <title>Storage Invoice</title>
</head>
<body>
  <p>Storage invoice generation not yet implemented</p>
</body>
</html>
  `;
};
